import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import {
  CallState as RewardsCallState,
  getFetchRewardsAccountsCallState,
  getRewardsAccounts,
  getRewardsAccountWithLargestEarnForBanner,
} from "../../../rewards/reducer";
import {
  getIsCreditCardPaymentRequired,
  getTotalToPay,
  getRewardsPaymentAccountReferenceId,
  getRewardsPaymentInFiatCurrency,
  getRewardsPaymentInRewardsCurrency,
  getTotalCreditCardPaymentRequiredNumber,
  rewardsAccountMinimumRequirementStateSelector,
  getCreditToApply,
  getOfferToApply,
  getTotalVacationRentalsCreditCardPaymentRequiredNumber,
  getVacationRentalsIsCreditCardPaymentRequired,
  getTotalVacationRentalsToPay,
} from "../../reducer/selectors";
import { IStoreState } from "../../../../reducers/types";
import { RewardsSelection } from "./component";
import { actions } from "../../actions";
import { getPremierCollectionShopSelectedAvailability } from "../../../shop/reducer";
import { getVacationRentalShopSelectedListing } from "../../../vacation-rental-shop/reducer";

const mapStateToProps = (state: IStoreState) => {
  const selectedHome = getVacationRentalShopSelectedListing(state);
  return {
    rewardsAccounts: getRewardsAccounts(state),
    rewardsAccountsLoaded: [
      RewardsCallState.Success,
      RewardsCallState.Failed,
    ].includes(getFetchRewardsAccountsCallState(state)),
    selectedRewardsPaymentAccountId: getRewardsPaymentAccountReferenceId(state),
    rewardsPaymentInFiatCurrency: getRewardsPaymentInFiatCurrency(state),
    rewardsPaymentInRewardsCurrency: getRewardsPaymentInRewardsCurrency(state),
    isCreditCardPaymentRequired: selectedHome
      ? getVacationRentalsIsCreditCardPaymentRequired(state)
      : getIsCreditCardPaymentRequired(state),
    rewardsAccountMinimumRequirementState:
      rewardsAccountMinimumRequirementStateSelector(state),
    totalCreditCardPaymentRequired: selectedHome
      ? getTotalVacationRentalsCreditCardPaymentRequiredNumber(state)
      : getTotalCreditCardPaymentRequiredNumber(state),
    tripTotal: selectedHome
      ? getTotalVacationRentalsToPay(state)
      : getTotalToPay(state),
    offerToApply: getOfferToApply(state),
    creditToApply: getCreditToApply(state),
    selectedLodging: getPremierCollectionShopSelectedAvailability(state),
    selectedHome,
    largestValueAccount: getRewardsAccountWithLargestEarnForBanner(state),
  };
};

const mapDispatchToProps = {
  setSelectedRewardsAccountId: actions.setSelectedRewardsAccountReferenceId,
  setRewardsPaymentAmount: actions.setSelectedRewardsPaymentTotal,
  fetchProductToEarn: actions.fetchProductToEarn,
  setRewardsConversionFailed: actions.setRewardsConversionFailed,
  setPaymentMethod: actions.setPaymentMethod,
  setEarnValue: actions.setEarnValue,
  fetchAllEarnForProduct: actions.fetchAllEarnForProduct,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type RewardsSelectionConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedRewardsSelection = withRouter(
  connector(RewardsSelection)
);
